const generatePresetLabel = (label, id) => {
  const idNumber = parseInt(id.split('-').pop(), 10);

  return Number.isNaN(idNumber) ? label : `${label} ${idNumber}`;
};

export default generatePresetLabel;
